import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { signInAction } from "../../actions/authActions";
import { connect } from "react-redux";
import {
  Container,
  Row,
  Col,
  CardGroup,
  Card,
  CardBody,
  Button,
  InputGroup,
} from "reactstrap";
import { PacmanLoader } from "react-spinners";
import { FormattedMessage } from "react-intl";
import { Format } from "react-intl-format";

class Signin extends Component {
  submit = (values) => {
    this.props.signInAction(values, this.props.history);
  };

  resetPassword = () => {
    this.props.history.push("/password/reset");
  };

  openManual = () => {
    window.open("http://ftp.pol.se/public/LearnWARE/manual_LWC.pdf", "_blank");
  };

  render() {
    const { handleSubmit } = this.props;

    if (this.props.auth.isLoggingIn) {
      return (
        <div
          className="sweet-loading"
          style={{ position: "fixed", top: "50%", left: "50%" }}
        >
          <PacmanLoader color={"#20a8d8"} loading={true} />
        </div>
      );
    }

    return (
      <div className="form">
        <Format>
          {(intl) => (
            <div className="app flex-row align-items-center">
              <Container>
                <Row className="justify-content-center">
                  <Col md="8">
                    <CardGroup>
                      <Card
                        className="text-white bg-primary py-5 d-md-down-none"
                        style={{ width: 44 + "%" }}
                      >
                        <CardBody className="text-center">
                          <div>
                            <img
                              style={{ width: 100 + "%" }}
                              src={"img/LearnWareLoggo.png"}
                              className="img-avatar"
                              alt="LearnWARE logga in"
                            />
                          </div>
                        </CardBody>
                      </Card>
                      <img
                        src={"img/m_logo.png"}
                        style={{
                          maxWidth: "92%",
                          position: "absolute",
                          top: "-190px",
                          marginLeft: "5px",
                        }}
                        alt="Signin logo"
                        className="d-lg-none img-responsive"
                      />
                      <Card className="p-4">
                        <CardBody>
                          <h1>
                            <FormattedMessage id="signin.header" />
                          </h1>
                          <p className="text-muted">
                            <FormattedMessage id="signin.ingress" />
                          </p>
                          <form onSubmit={handleSubmit(this.submit)}>
                            <InputGroup className="mb-3">
                              <Field
                                autoFocus={true}
                                name="email"
                                autoComplete="username"
                                style={{ padding: "5px" }}
                                component="input"
                                type="email"
                                required
                                placeholder={intl.formatMessage({
                                  id: "signin.placeholder.username",
                                })}
                              />
                            </InputGroup>
                            <InputGroup className="mb-4">
                              <Field
                                name="password"
                                autoComplete="current-password"
                                style={{ padding: "5px" }}
                                component="input"
                                type="password"
                                required
                                placeholder={intl.formatMessage({
                                  id: "signin.placeholder.password",
                                })}
                              />
                            </InputGroup>
                            <Row>
                              <Col xs="6">
                                <Button
                                  type="submit"
                                  color="primary"
                                  className="px-4"
                                >
                                  <FormattedMessage id="signin.button.login" />
                                </Button>
                              </Col>
                              <Col xs="6" className="text-right">
                                <Button
                                  type="button"
                                  color="link"
                                  className="px-0"
                                  onClick={this.resetPassword}
                                >
                                  <FormattedMessage id="signin.button.forgotpassword" />
                                </Button>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                {this.props.auth.error && (
                                  <div className="info-red">
                                    <FormattedMessage
                                      id={this.props.auth.error}
                                    />
                                  </div>
                                )}
                              </Col>
                            </Row>
                            <Row>
                              <Col xs="6">
                                <Button
                                  type="button"
                                  color="link"
                                  className="px-0"
                                  onClick={this.openManual}
                                >
                                  <FormattedMessage id="Manual" />
                                </Button>
                              </Col>
                            </Row>
                          </form>
                        </CardBody>
                      </Card>
                    </CardGroup>
                  </Col>
                </Row>
              </Container>
            </div>
          )}
        </Format>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { auth: state.auth.auth };
}

const reduxFormSignin = reduxForm({
  form: "signin",
})(Signin);

export default connect(mapStateToProps, { signInAction })(reduxFormSignin);
